import React, { memo, useCallback } from 'react';

import { Card, IconButton, Typography, useTheme } from '@mui/material';
import { DeleteIcon } from '@sharedCR/coreDesignSystem/icons';
import PropType from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { ActivitiesTestIds } from '../../../Activities.testIds';
import { getStyles } from '../../EmailCreationModal.styles';

const MAX_FILENAME_LENGTH = 25;

const trimFileName = fileName => {
  const extension = fileName.slice(fileName.lastIndexOf('.'));

  return fileName.length <= MAX_FILENAME_LENGTH
    ? fileName
    : `${fileName.slice(0, MAX_FILENAME_LENGTH - extension.length)}... ${extension}`;
};

const EmailAttachments = ({ files, setFiles }) => {
  const theme = useTheme();
  const classes = getStyles(theme);

  const onRemoveFile = useCallback(
    e => {
      const { name } = e.currentTarget.dataset;

      if (name) {
        setFiles(prevFiles => prevFiles.filter(file => file.name !== name));
      }
    },
    [setFiles],
  );

  return (
    <div className="flex flex-wrap">
      {files.map(({ name }, index) => (
        <Card className="flex w-320 m-12 rounded-4" elevation={2} key={name} sx={classes.fileCard}>
          <div className="flex justify-between items-center w-full p-12">
            <Typography className="text-white" variant="medium14">
              {trimFileName(name)}
            </Typography>
            <IconButton
              data-name={name}
              data-testid={ActivitiesTestIds.getRemoveAttachmentButtonId(index)}
              size="small"
              onClick={onRemoveFile}
            >
              <DeleteIcon size={IconSize[20]} />
            </IconButton>
          </div>
        </Card>
      ))}
    </div>
  );
};

EmailAttachments.propTypes = {
  files: PropType.arrayOf(PropType.object).isRequired,
  setFiles: PropType.func.isRequired,
};

export default memo(EmailAttachments);
